export function getPlayFrom(queryString) {
    const urlParams = new URLSearchParams(queryString.toLowerCase());
    const playFromParam = urlParams.get('playfrom');
    if (playFromParam) {
        return parseFloat(playFromParam) / 1000;
    }
}

export function getDuration(queryString) {
    const urlParams = new URLSearchParams(queryString.toLowerCase());
    const durationParam = urlParams.get('duration');
    if (durationParam) {
        return parseFloat(durationParam) / 1000;
    }
}

export function getPresentationId(pathname) {
    const splitPath = pathname.split('/');
    return splitPath[splitPath.length - 1];
}

export function getLockControls(queryString) {
    const urlParams = new URLSearchParams(queryString.toLowerCase());
    const lockControlsValue = urlParams.get('lockcontrols');
    return (lockControlsValue === 'true');
}

export class QueryStringParamProvider {
    #rawParams;
    #lowerParams;

    constructor(queryString) {
        this.#rawParams = new URLSearchParams(queryString.toLowerCase());
        this.#lowerParams = new URLSearchParams();
        for (const [name, value] of this.#rawParams) {
            this.#lowerParams.append(name.toLowerCase(), value);
        }
    }

    getParam(paramName) {
        paramName = paramName.toLowerCase();
        return this.#lowerParams.get(paramName);
    }

    getParamCaseSensitive(paramName, defaultValue) {
        return this.#rawParams.get(paramName);
    }

}